import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Star, Gift, CreditCard, Users, Trophy, ArrowRight, Sparkles } from "lucide-react";

const LoyaltyProgramPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-black">
      <Header />
      
      <main className="flex-1 max-w-5xl mx-auto px-4 py-8 w-full">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full mb-6">
            <Star className="w-10 h-10 text-black" />
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Programma Fedeltà
          </h1>
          <p className="text-xl text-zinc-400 max-w-2xl mx-auto">
            Accumula punti con ogni ordine e ottieni premi esclusivi!
          </p>
        </div>

        {/* Come guadagnare punti */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-white mb-6 flex items-center gap-3">
            <Sparkles className="w-6 h-6 text-yellow-500" />
            Come guadagnare punti
          </h2>
          
          <div className="grid md:grid-cols-3 gap-6">
            {/* 1 punto per euro */}
            <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 hover:border-green-500/50 transition-colors">
              <div className="w-12 h-12 bg-green-500/20 rounded-lg flex items-center justify-center mb-4">
                <span className="text-2xl font-bold text-green-500">1€</span>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">1 Punto per Euro</h3>
              <p className="text-zinc-400">
                Per ogni euro speso guadagni <span className="text-green-500 font-semibold">1 punto</span>. 
                Più ordini, più punti accumuli!
              </p>
            </div>

            {/* Bonus pagamento carta */}
            <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 hover:border-blue-500/50 transition-colors">
              <div className="w-12 h-12 bg-blue-500/20 rounded-lg flex items-center justify-center mb-4">
                <CreditCard className="w-6 h-6 text-blue-500" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2">+5 Punti Carta</h3>
              <p className="text-zinc-400">
                Pagando in anticipo con carta ottieni <span className="text-blue-500 font-semibold">+5 punti bonus</span> su ogni ordine!
              </p>
            </div>

            {/* Bonus stessa fascia */}
            <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 hover:border-yellow-500/50 transition-colors">
              <div className="w-12 h-12 bg-yellow-500/20 rounded-lg flex items-center justify-center mb-4">
                <Users className="w-6 h-6 text-yellow-500" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2">+10 Punti Gruppo</h3>
              <p className="text-zinc-400">
                Ordini nella stessa fascia oraria di altri clienti? 
                Ottieni <span className="text-yellow-500 font-semibold">+10 punti bonus</span>!
              </p>
            </div>
          </div>

          {/* Info box bonus gruppo */}
          <div className="mt-6 bg-yellow-500/10 border border-yellow-500/50 rounded-lg p-4">
            <p className="text-yellow-500 text-sm">
              <strong>Come funziona il bonus gruppo?</strong> Quando scegli una fascia oraria di consegna, 
              vedrai indicate le fasce con altri ordini già presenti nella tua zona. 
              Scegliendo queste fasce aiuti ad ottimizzare le consegne e guadagni 10 punti extra!
            </p>
          </div>
        </section>

        {/* I Premi */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-white mb-6 flex items-center gap-3">
            <Trophy className="w-6 h-6 text-yellow-500" />
            I Premi
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            {/* Premio 250 punti */}
            <div className="bg-gradient-to-br from-green-500/10 to-green-600/5 border border-green-500 rounded-xl p-6 relative overflow-hidden">
              <div className="absolute top-4 right-4 bg-green-500 text-black px-3 py-1 rounded-full text-sm font-bold">
                300 PUNTI
              </div>
              <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mb-4">
                <Gift className="w-8 h-8 text-green-500" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2">Piatto in Omaggio</h3>
              <p className="text-zinc-400 mb-4">
                Raggiungi 300 punti e scegli un piatto gratuito dal nostro catalogo! 
                Potrai selezionarlo direttamente al checkout.
              </p>
              <div className="flex items-center gap-2 text-green-500">
                <span className="text-sm font-medium">Disponibile subito al checkout</span>
              </div>
            </div>

            {/* Premio 3000 punti */}
            <div className="bg-gradient-to-br from-purple-500/10 to-purple-600/5 border border-purple-500 rounded-xl p-6 relative overflow-hidden">
              <div className="absolute top-4 right-4 bg-purple-500 text-white px-3 py-1 rounded-full text-sm font-bold">
                3000 PUNTI
              </div>
              <div className="w-16 h-16 bg-purple-500/20 rounded-full flex items-center justify-center mb-4">
                <span className="text-3xl">✨</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">Esperienza per Due</h3>
              <p className="text-zinc-400 mb-4">
                Un premio speciale: un'esperienza esclusiva per due persone presso uno dei nostri partner selezionati.
              </p>
              <div className="flex items-center gap-2 text-purple-400">
                <span className="text-sm font-medium">Premio esclusivo</span>
              </div>
            </div>
          </div>
        </section>

        {/* Esempio pratico */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-white mb-6">Esempio pratico</h2>
          
          <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6">
            <div className="flex flex-col md:flex-row items-center gap-6">
              <div className="flex-1">
                <p className="text-zinc-300 mb-4">
                  <strong className="text-white">Ordine da €50 pagato con carta, nella stessa fascia di altri ordini:</strong>
                </p>
                <ul className="space-y-2 text-zinc-400">
                  <li className="flex items-center gap-2">
                    <span className="text-green-500">✓</span> 50 punti base (1€ = 1 punto)
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-blue-500">✓</span> +5 punti bonus carta
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-yellow-500">✓</span> +10 punti bonus gruppo
                  </li>
                </ul>
              </div>
              <div className="bg-black rounded-xl p-6 text-center">
                <p className="text-zinc-500 text-sm mb-1">TOTALE PUNTI</p>
                <p className="text-4xl font-bold text-green-500">65</p>
                <p className="text-zinc-500 text-sm mt-1">punti guadagnati</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="text-center">
          <div className="bg-gradient-to-r from-green-500/20 to-yellow-500/20 border border-green-500/50 rounded-xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">
              Inizia ad accumulare punti!
            </h2>
            <p className="text-zinc-400 mb-6 max-w-xl mx-auto">
              Registrati gratuitamente e inizia a guadagnare punti con ogni ordine. 
              Ricevi subito <span className="text-green-500 font-semibold">20 punti di benvenuto</span>!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/accedi"
                className="inline-flex items-center justify-center gap-2 bg-green-500 text-black px-6 py-3 rounded-lg font-bold hover:bg-green-400 transition-colors"
              >
                Registrati ora
                <ArrowRight className="w-5 h-5" />
              </Link>
              <Link 
                to="/catalogo"
                className="inline-flex items-center justify-center gap-2 bg-zinc-800 text-white px-6 py-3 rounded-lg font-bold hover:bg-zinc-700 transition-colors"
              >
                Vai al catalogo
              </Link>
            </div>
          </div>
        </section>

        {/* Note */}
        <section className="mt-8">
          <p className="text-zinc-500 text-sm text-center">
            Il programma fedeltà è riservato ai clienti privati. Le aziende non accumulano punti.
            <br />
            I punti non hanno scadenza e possono essere utilizzati su qualsiasi ordine.
          </p>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default LoyaltyProgramPage;
